import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useGetProtectedApiDataQuery } from "../redux/services/apiSlice";
import { convertSymbolCodes } from "../Utils/utils";

const useSeo = ({ pathname }) => {
  const { languageType } = useSelector((state) => state.homeSlice);

  const { data: metaData = [] } = useGetProtectedApiDataQuery({
    url: "metadata",
    lang: languageType,
  });

  const meta = metaData.find(
    (item) => convertSymbolCodes(item.field_page_url) === pathname
  );

  useEffect(() => {
    if (meta) {
      const { title, field_description, field_keywords } = meta;

      // Set the page title
      const siteName = languageType === "hi" ? "नीपको" : "NEEPCO";
      document.title = `${convertSymbolCodes(title)} | ${siteName}`;

      // Set the meta description
      const metaDescription = document.querySelector(
        "meta[name='description']"
      );
      if (metaDescription) {
        metaDescription.setAttribute("content", field_description);
      }

      // Set the meta keywords
      const keywordsMeta = document.querySelector("meta[name='keywords']");
      if (keywordsMeta) {
        keywordsMeta.setAttribute("content", field_keywords);
      }
    }
  }, [pathname, languageType, meta]);

  return {
    innerBannerImage: meta?.field_breadcrum_banner_image,
    innerBannerTitle: meta?.title,
  };
};

export default useSeo;
